
export default {
  'profile.management.manage_profile': 'Administra Tu Perfil',
  'profile.management.view_public_profile': 'Ver Perfil Público',
  'profile.management.save_changes': 'Guardar Cambios',
  'profile.management.saving': 'Guardando...',
  'profile.management.profile_updated': 'Perfil Actualizado',
  'profile.management.profile_update_error': 'Error al actualizar tu perfil.',
  'profile.management.error': 'Error',
  'profile.management.profile_information': 'Información del Perfil',
  'profile.management.update_profile_information': 'Actualiza la información básica de tu perfil que será visible para los clientes.',
  'profile.management.display_name': 'Nombre para Mostrar',
  'profile.management.your_display_name': 'Tu nombre para mostrar',
  'profile.management.age': 'Edad',
  'profile.management.city': 'Ciudad',
  'profile.management.your_city': 'Tu ciudad',
  'profile.management.country': 'País',
  'profile.management.your_country': 'Tu país',
  'profile.management.short_bio': 'Biografía Corta (limitada a 100 caracteres)',
  'profile.management.brief_description': 'Una breve descripción de ti mismo/a',
  'profile.management.characters': 'caracteres',
  'profile.management.full_bio': 'Biografía Completa',
  'profile.management.tell_about_yourself': 'Cuéntale a los clientes potenciales sobre ti, tus servicios y lo que te hace especial',
  'profile.management.physical_attributes': 'Atributos Físicos',
  'profile.management.height': 'Altura (cm)',
  'profile.management.height_in_cm': 'Altura en cm',
  
  // Translation status
  'profile.management.translation_status': 'Estado de Traducción',
  'profile.management.translate_missing': 'Traducir Faltantes',
  'profile.management.translate_all_languages': 'Traducir a Todos los Idiomas',
  'profile.management.translating': 'Traduciendo...',
  'profile.management.translation_complete': 'Traducción Completa',
  'profile.management.profile_translated_all_languages': 'Tu perfil ha sido traducido a todos los idiomas compatibles.',
  'profile.management.translation_error': 'Hubo un error al traducir tu perfil.',
  'profile.management.profile_translation_success': 'Tu perfil ha sido actualizado y se han generado las traducciones.',
  
  // Tabs
  'profile.management.tabs.basic_info': 'Información Básica',
  'profile.management.tabs.photos_media': 'Fotos y Medios',
  'profile.management.tabs.services_rates': 'Servicios y Tarifas',
  'profile.management.tabs.availability': 'Disponibilidad',
  'profile.management.tabs.settings': 'Configuración',
  
  // Admin image upload
  'profile.management.upload_image': 'Subir Imagen',
  'profile.management.upload_image_success': 'Imagen subida con éxito',
  'profile.management.upload_image_error': 'Error al subir la imagen',
  'profile.management.select_profile': 'Seleccionar Perfil',
  'profile.management.upload': 'Subir',
  'profile.management.admin_tools': 'Administrar Imágenes de Perfil'
};
